module.exports = __webpack_public_path__ + "media/tocata.257df343.mp3";